import { useRef } from 'react';
import ButtonBase from '@mui/material/ButtonBase';
import { useToggle } from '@/hooks/useToggle';
import Menu, { MenuItem } from '@/components/Menu';
import { CaretDownIcon } from '@/icons';
import { type Speed, SPEEDS } from './constants';
import { classes, formatSpeed, styles } from './utils';

export type { Speed };

export type PlaybackSpeedMenuProps = {
  speed: Speed;
  onChange: (speed: Speed) => void;
};

export default function PlaybackSpeedMenu({
  speed,
  onChange,
}: PlaybackSpeedMenuProps) {
  const buttonRef = useRef(null);
  const [isMenuOpen, toggleMenu] = useToggle();

  const handleSelect = (s: Speed) => {
    onChange(s);
    toggleMenu();
  };

  return (
    <>
      <ButtonBase
        ref={buttonRef}
        sx={styles.button}
        className={classes.button}
        onClick={() => toggleMenu()}>
        <label className={classes.label}>{formatSpeed(speed)}</label>
        <CaretDownIcon className={classes.caret} />
      </ButtonBase>
      {isMenuOpen && (
        <Menu
          anchorTo={buttonRef.current}
          open
          transformOrigin={{ horizontal: 'center', vertical: 'bottom' }}
          anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
          onClose={() => toggleMenu()}>
          {SPEEDS.map((s) => (
            <MenuItem
              key={s}
              label={formatSpeed(s)}
              onClick={() => handleSelect(s)}
            />
          ))}
        </Menu>
      )}
    </>
  );
}
